//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionRenameFill(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M13.09 5L2 16.09V21H6.91L18 9.90997L13.09 5ZM20.83 7.08002L15.92 2.16998L14.5 3.59003L19.41 8.5L20.83 7.08002ZM21.43 19.43C21.0228 19.7616 20.5237 19.9606 20 20C19.6 20 19.46 19.88 19.06 18.74C18.66 17.6 18.23 16.38 16.64 16.05C14.08 15.54 11.95 17.83 9.25 20.74L9 21H11.74C13.53 19.11 15.01 17.77 16.23 18C16.66 18.09 16.85 18.49 17.16 19.39C17.47 20.29 18.08 22 20 22C21.0543 21.9438 22.0602 21.5393 22.86 20.85L21.43 19.43Z" fill="currentColor" /></svg>;
}
export default IconActionRenameFill;